import CardContainer from '../../../components/cards/layout/CardContainer';
import CardGrid from '../../../components/cards/layout/CardGrid';
import PictureNameCard from '../../../components/cards/PictureNameCards/PictureNameCard';
import { RequestController } from './ExtendTimeCorrection';
import {
  TravelExpenseRequestHeader,
  TravelExpenseRequestDetails,
} from '../../new-requests/extended-request-versions/ExtendTravelExpense';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import Feedback from '../../../components/special/Feedback';

export const ExtendTravelExpense = ({ request, onUpdate }) => {
  const { t } = useTranslation();

  const requester = request.requestedBy || request.user;

  // feedback
  const [alertState, setAlertState] = useState({
    alertOpen: false,
    alertType: 'info',
    alertText: 'test',
  });
  function handleAlertOpen(text, type) {
    setAlertState({ alertOpen: true, alertText: text, alertType: type });
  }

  return (
    <>
      <CardGrid>
        <CardContainer span={5}>
          <TravelExpenseRequestHeader request={request} />
        </CardContainer>
        <CardContainer span={5}>
          <TravelExpenseRequestDetails request={request} />
        </CardContainer>
        <PictureNameCard
          data={requester}
          type="user"
          title={t('Requester')}
          pictureUrl={requester.picture ? requester.picture.temporaryUrl : ''}
          name={`${requester.firstName} ${requester.lastName}`}
          mail={requester.email}
          phone={requester.phone}
          position={requester.position}
        />

        <CardContainer>
          <RequestController
            request={request}
            onUpdate={onUpdate}
            onFeedback={handleAlertOpen}
          />
        </CardContainer>
        {request.processedBy && (
          <PictureNameCard
            data={request.processedBy}
            type="user"
            title={t('Processor')}
            pictureUrl={
              request.processedBy.picture
                ? request.processedBy.picture.temporaryUrl
                : ''
            }
            name={`${request.processedBy.firstName} ${request.processedBy.lastName}`}
            mail={request.processedBy.email}
            phone={request.processedBy.phone}
            position={request.processedBy.position}
          />
        )}
      </CardGrid>
      <Feedback setState={setAlertState} state={alertState} />
    </>
  );
};

export default ExtendTravelExpense;
